import PropTypes from 'prop-types'
import React, { Component } from 'react'
import uuid from 'uuid'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import ReactGA from 'react-ga4'
import * as Sentry from '@sentry/react'

import { notification, changeLocale } from 'redux/modules/app'
import * as authActions from 'redux/modules/auth'
import {
  getUserType,
  hasUserRole,
  hasMultipleRoles,
  selectFirstOrganization,
  hasOnlyAssessorRoles, selectFirstAssessorOrganization
} from 'utils/token'
import { awards as awardsApi } from 'redux/modules/api/combineDashboard'
import { ROLES } from 'constants/enums'
import { getActiveAwardId } from 'helpers/getActiveAward'
import { fetchAwardSuccess } from 'redux/modules/api/dashboard/awards'
import { apiLocales } from 'helpers/decorators/api'
import { modal } from 'helpers/decorators'
import config from 'config'
import MODALS from 'constants/layout/modals'
import { getCustomHomePageCode } from '../../../../utils/cookies'
import MODAL from '../../../../constants/layout/modals'

function decorator () {
  return ComposedComponent => {
    const enhance = compose(
      connect(null, {
        ...authActions,
        changeLocale,
        notification,
        push,
        loadAward: awardsApi.loadAward,
        fetchAwardSuccess
      }),
      apiLocales(),
      modal.trigger(),
      injectIntl
    )

    class Login extends Component {
      static propTypes = {
        changeLocale: PropTypes.func.isRequired,
        fetchAwardSuccess: PropTypes.func,
        intl: PropTypes.object.isRequired,
        loadAward: PropTypes.func.isRequired,
        loginBulk: PropTypes.func.isRequired,
        mfaVerify: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        onOpen: PropTypes.func,
        push: PropTypes.func.isRequired,
        saveUser: PropTypes.func.isRequired,
        saveUserBo: PropTypes.func.isRequired,
        setActiveOrg: PropTypes.func.isRequired,
        modal: PropTypes.func
      }

      setSentryUser = (body, role) => {
        const personId = get(body, 'personId')

        Sentry.setUser({
          personId,
          role,
          locale: get(body, 'personLocale')
        })
      }

      handleLogin = async (fields) => {
        try {
          const res = await this.props.loginBulk(fields)
          await this.handleLoginSuccess(res)
        } catch (err) {
          this.handleLoginError(err)
        }
      }

      handleSetMfaCode = async (fields) => {
        try {
          const res = await this.props.mfaVerify(fields)
          await this.handleLoginSuccess(res)
        } catch (err) {
          this.handleLoginError(err)
          this.props.push(`${config.publicPath}/`)
        }
      }

      handleLoginSuccess = ({ body = {} }) => {
        if (get(body, 'is_psw_exp')) {

          const userType = get(body, 'userTypes')[0]

          this.props.onOpen(MODALS.CHANGE_OLD_PASSWORD, null, {
            id: get(body, 'participantId'),
            userType: get(userType, 'userType') || null,
            orgId: get(userType, 'organizations')[0].id || null
          })

        } else if (get(body, 'loginId')) {
          if (get(body, 'secret')) {
            this.props.push(`${config.publicPath}/mfa/code`)
          } else {
            this.props.onOpen(MODAL.SET_MFA_CODE, null, null)
          }

        } else {
          const generatedId = uuid.v1() + body.personId

          if (getUserType(body) === ROLES.PARTICIPANT.u) {
            this.handleLoginFO(body)
          } else if (hasUserRole(body, ROLES.ASSESSOR.u) && hasOnlyAssessorRoles(body)) {
            return this.handleLoginFOAssessor(body, generatedId)
          } else {
            this.handleLoginBO(body, generatedId)
          }

          if (getUserType(body) === ROLES.PARTICIPANT.u) {
            this.handleLoginFO(body)
          } else {
            this.handleLoginBO(body, generatedId)
          }
        }
      }

      handleLoginFO = body =>
        this.props
          .saveUser(body)
          .then(res => {
            if (!res.body) {
              return
            }

            const localeObj = get(this.props, 'locales.data', []).find(
              item => item.code === get(res, 'body.personLocale')
            )

            this.setSentryUser(get(res, 'body'), ROLES.PARTICIPANT.u)

            this.props.changeLocale(localeObj)
            this.props.setActiveOrg({
              id: null,
              role: ROLES.PARTICIPANT.u
            })
          })
          .then(() => this.props.loadAward())
          .then(({ body } = {}) => {
            const activeId = getActiveAwardId(body)

            const currAward = body && body.length > 1
              ? body.find(award => award.id === activeId)
              : body[0]

            ReactGA.event({
              category: 'Participant',
              action: 'Logged in'
            })

            this.props.fetchAwardSuccess(currAward)

            if (activeId) {
              this.props.push(`${config.publicPath}/dashboard/awards/${activeId}`)
            } else {
              this.props.push('${config.publicPath}/dashboard')
            }
          })
          .catch(err => this.handleLoginError(err))

      handleLoginFOAssessor = (body, generatedId) => {
        return new Promise(resolve => {
          this.setSentryUser(body, ROLES.ASSESSOR.u)

          this.props.setActiveOrg({ id: null, role: ROLES.ASSESSOR.u })
          return resolve({
            ...selectFirstAssessorOrganization(body),
            userType: ROLES.ASSESSOR.u
          })
        })
          .then(chosenRole => {
            if (!chosenRole || !chosenRole.id) {
              return
            }

            if (chosenRole.userType !== ROLES.ASSESSOR.u) {
              this.handleLoginBO(body, generatedId, chosenRole)
              return chosenRole
            }

            this.props.setActiveOrg({
              id: chosenRole.id,
              role: chosenRole.userType
            })
            return chosenRole
          })
          .then(chosenRole => {
            if (get(chosenRole, 'userType') === ROLES.ASSESSOR.u) {
              this.props.saveUser(body).then(res => {
                const localeObj = get(this.props, 'locales.data', []).find(
                  item => item.code === get(res, 'body.personLocale')
                )

                this.setSentryUser(body, ROLES.ASSESSOR.u)

                this.props.changeLocale(localeObj)

                return this.props.push(`${config.publicPath}/assessor`)
              })
            }
          })
      }

      handleLoginBO = (body, generatedId, prefferedOrganisation) => {

        if (!prefferedOrganisation && hasMultipleRoles(body)) {

          return new Promise(resolve => {
            this.props.onOpen(MODALS.CHANGE_ROLE, null, {
              onResolve: resolve,
              userTypes: get(body, 'userTypes')
            })
          }).then(chosenRole => {
            if (get(chosenRole, 'userType') === ROLES.ASSESSOR.u) {
              return this.handleLoginFOAssessor(body, generatedId)
            } else {
              this.handleSaveUserOnBackOffice(body, generatedId, chosenRole)
            }
          })
        }

        this.handleSaveUserOnBackOffice(
          body,
          generatedId,
          prefferedOrganisation
        )
      }

      handleSaveUserOnBackOffice = (
        body,
        generatedId,
        prefferedOrganisation
      ) => {
        const user = {
          ...body,
          prefferedOrganisation
        }

        this.props
          .saveUserBo({ userInfo: user, generatedId })
          .then(() => {
            this.setSentryUser(body, get(body, 'userTypes'))

            ReactGA.event({
              category: 'Award staff',
              action: 'Logged'
            })

            const storedCode = getCustomHomePageCode()
            if (storedCode !== null) {
              window.location.replace(`${config.boUrl}/login?id=${generatedId}&pageCode=${storedCode}`)
            } else {
              window.location.replace(`${config.boUrl}/login?id=${generatedId}`)
            }

          })
          .catch(this.handleLoginError)
      }

      handleLoginError = ({ body = {} } = {}) => {
        if (body.errorCode === 'NONE_USER_TYPE_IN_TOKEN') {
          return this.showWrongTab()
        }

        if (body.errorCode === 'OFFLINE_PARTICIPANT') {
          return this.showLoginForOffline()
        }

        if (body.statusCode === 502) {
          this.props.notification('Server unreachable', 'error')
          return
        }

        if (
          get(this, 'component.state.isAwardStaff') === true &&
          get(body, 'developerMessage', '').includes('userType in JWT token')
        ) {
          return this.props.notification(
            this.props.intl.formatMessage({
              id: 'notifications.login_failed_right_tab',
              defaultMessage: 'Login unsuccessful. Make sure you are in the correct tab (Participant / Award Staff).'
            }),
            'error'
          )
        }

        console.log('ERR', body)
        this.props.notification(
          (body && body.userMessage) || 'Login failed.',
          'error'
        )
      }

      showWrongTab = () =>
        this.props.notification(
          'Login unsuccessful',
          {
            status: 'error',
            intlKey: 'notifications.login_failed'
          }
        )

      showLoginForOffline = () =>
        this.props.notification(
          'Login unsuccessful',
          {
            status: 'error',
            intlKey: 'notifications.offline_login'
          }
        )

      render () {
        return (
          <ComposedComponent
            ref={c => this.component = c}
            {...this.props}
            onLogin={this.handleLogin}
            onSetMfaCode={this.handleSetMfaCode}
          />
        )
      }
    }

    return enhance(Login)
  }
}

export default decorator
